import { Col, Row, Form, DatePicker } from "antd";
import React from "react";
import { formatFullMonthName } from "../../../helpers/formatDate";
import EstablishmentFormItem from "../EstablishmentFormItem/EstablishmentFormItem";

const GenerateReportForm = ({ handleChange = (value) => {} }) => {
  return (
    <>
      <Row>
        <Col span={24}>
          <EstablishmentFormItem handleChange={handleChange} />
        </Col>
      </Row>
      <Row gutter={10}>
        <Col span={12}>
          <Form.Item
            labelAlign="left"
            label="Month"
            name={"month"}
            rules={[
              {
                required: true,
                message: "Please select a month!",
              },
            ]}
          >
            <DatePicker
              allowClear={false}
              picker="month"
              format={(value) => formatFullMonthName(value)}
              style={{ width: "100%" }}
              placement="bottomLeft"
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            labelAlign="left"
            label="Year"
            name={"year"}
            rules={[
              {
                required: true,
                message: "Please select a year!",
              },
            ]}
          >
            <DatePicker
              allowClear={false}
              picker="year"
              style={{ width: "100%" }}
              placement="bottomLeft"
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default GenerateReportForm;
